import { Component } from "react"
import PropTypes from "prop-types"
import moment from "moment"

export default class Delay extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reminderTime: props.time.fromNow(),
    }
  }

  static propTypes = {
    time: PropTypes.object.isRequired,
  }

  componentDidMount() {
    // add the interval
    this.interval = setInterval(() => {
      if (moment().isAfter(this.props.time)) {
        this.setState({
          reminderTime: "soon",
        })
      } else {
        this.setState({
          reminderTime: this.props.time.fromNow(),
        })
      }
    }, 3000)
  }

  componentWillUnmount() {
    // remove the interval listener
    clearInterval(this.interval)
  }

  render() {
    return this.state.reminderTime
  }
}
